import script from "./PDFVuer.vue?vue&type=script&setup=true&lang=js"
export * from "./PDFVuer.vue?vue&type=script&setup=true&lang=js"

import "./PDFVuer.vue?vue&type=style&index=0&id=c8c1e67e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8c1e67e"]])

export default __exports__